<script lang="ts" setup>
import { Button } from '@brighterly/lib-lumee-ui'

import { useSubscriptionStore } from '@entities/subscription'
import { useFailedPaymentRetry } from '@entities/subscription'
import { AppRoute } from '@shared/config'
import { trackEvent } from '@shared/lib/amplitude'

import bg from './bg.png'

defineOptions({
  name: 'ModalRetryPayment',
})

const AppModal = defineAsyncComponent(() => import('@shared/ui/modals').then((module) => module.AppModal))

const subscriptionStore = useSubscriptionStore()

const {
  name,
  btnText,
  setSubmit,
} = useFailedPaymentRetry()

onMounted(() => {
  trackEvent('Popup_view', {
    feature: 'subscription',
    name,
    text: subscriptionStore.getPaymentRetryErrorTitle,
    subscription_id: subscriptionStore.getPaymentRetrySubscriptionId,
  })
})

const setClose = (): void => {
  trackEvent('Popup_close', {
    feature: 'subscription',
    name,
    value: 'close_button',
    subscription_id: subscriptionStore.getPaymentRetrySubscriptionId,
  })
  subscriptionStore.setRetryPaymentModal(false)
}

const setCheckPaymentMethod = (): void => {
  const url = AppRoute.PaymentsMethods

  trackEvent('Button_click', {
    feature: 'subscription',
    name: 'check_payment_method',
    text: 'Check payment method',
    url,
    subscription_id: subscriptionStore.getPaymentRetrySubscriptionId,
  })

  subscriptionStore.setRetryPaymentModal(false)

  if (url) navigateTo(url)
}

</script>

<template>
  <AppModal
    :loading="subscriptionStore.isLoading"
    @close="setClose"
  >
    <template #topSlot>
      <div class="retry-payment__hero">
        <img
          :src="bg"
          alt="error illustration"
        >
      </div>
    </template>
    <template #contentSlot>
      <div class="retry-payment__content">
        <h5 class="retry-payment__title-xl btly-text-title-xl">
          {{ subscriptionStore.getPaymentRetryErrorTitle }}
        </h5>
        <div class="retry-payment__body-l btly-text-body-l">
          {{ subscriptionStore.getPaymentRetryErrorText }}
        </div>
      </div>
    </template>
    <template #bottomSlot>
      <Button
        fill
        :text="btnText"
        :disabled="subscriptionStore.isLoading"
        @click="setSubmit"
      />
      <Button
        view="secondary"
        fill
        text="Check payment method"
        :disabled="subscriptionStore.isLoading"
        @click="setCheckPaymentMethod"
      />
    </template>
  </AppModal>
</template>

<style scoped lang="scss" src="./ModalRetryPayment.scss" />
